import Vue from 'vue';
import TreeView from '@/components/officemanagement/TreeView.vue';
import AgencyLevel from '@/components/officemanagement/AgencyLevel.vue';

Vue.component('TreeView', TreeView);
Vue.component('AgencyLevel', AgencyLevel);
